export const buttonStyles = {
  height: 'fit-content',
  alignItems: 'flex-start',
};
